export enum MongoAuthMechanism {
    "SHA1",
    "SHA256"
}